import { BrowserRouter, Routes, Route } from "react-router";
import NavBarAuth from './auth/NavBar.jsx';
import NavBarWork from './work/NavBar.jsx';
import NavBarMain from './main/NavBar.jsx';
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { checkTokenAsync, getPickAsync } from "./api/auth.jsx";

function App() {

  const [jwt, setJwt] = useState(localStorage.getItem('jwt'));
  const [pick, setPick] = useState();
  const [isLoad, setIsLoad] = useState(true);

  const updateToken = (token) => {

    localStorage.setItem('jwt', token);
    setJwt(token);
  }

  useEffect(() => {
    let isCurrent = true;

    async function loadPick() {
      setIsLoad(true);

      if (!jwt) {
        setPick(undefined);
        setIsLoad(false);
        return;
      }

      try {
        const tokenResponse = await checkTokenAsync(jwt);
        if (!tokenResponse.ok)
          throw new Error(`Token check failed: ${tokenResponse.status}`);

        const pickResponse = await getPickAsync(jwt);
        if (!pickResponse.ok)
          throw new Error(`Pickup account request failed: ${pickResponse.status}`);

        const account = await pickResponse.json();
        if (isCurrent)
          setPick(account);
      } catch (error) {
        console.error(error);
        localStorage.removeItem('jwt');
        if (isCurrent)
          setPick(undefined);
      } finally {
        if (isCurrent)
          setIsLoad(false);
      }
    }

    loadPick();

    return () => {
      isCurrent = false;
    };

  }, [jwt]);

  if (isLoad)
    return <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <Spinner animation="border" style={{ width: 48, height: 48 }} variant="primary" />
    </div>

  return <BrowserRouter>
    <Routes>
      <Route path="/*" element={pick ? <NavBarWork pick={pick} jwt={jwt} /> : <NavBarMain />} />
      <Route path="/auth/*" element={<NavBarAuth onAuth={v => updateToken(v)} />} />
      {
        pick ?
          <Route path="/work/*" element={<NavBarWork pick={pick} jwt={jwt} />} /> : ''
      }
    </Routes>
  </BrowserRouter>
}

export default App;
